<template lang="pug">
.row.bs-wizard(
    :class="{ 'completed': status == 1 }"
)
    .col-xs-4.bs-wizard-step.complete
        .text-center.bs-wizard-stepnum Create
        .progress
            .progress-bar
        a.bs-wizard-dot(href="#")
        .bs-wizard-info.text-center

    .col-xs-4.bs-wizard-step(
        :class="{ 'complete': status == 0 || status == 1, 'disabled': status == null }"
    )
        .text-center.bs-wizard-stepnum Editing
        .progress
            .progress-bar
        a.bs-wizard-dot(href="#")
        .bs-wizard-info.text-center

    .col-xs-4.bs-wizard-step(
        :class="{ 'complete': status == 1, 'disabled': status == null || status == 0 }"
    )
        .text-center.bs-wizard-stepnum Shipped
        .progress
            .progress-bar
        a.bs-wizard-dot(href="#")
        .bs-wizard-info.text-center
</template>

<script>
export default {
    props: {
        status: {
            type: Number,
            default: null,
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_return/stock-return-step.vue